// Phase 9 follow-up (user-approved): client-side CSV export for the admin
// analytics tab. Data is already fetched for the charts — no extra API calls.
const esc = (v) => {
  const s = v === null || v === undefined ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function toCsv(rows, columns) {
  return [
    columns.join(","),
    ...rows.map((r) => columns.map((c) => esc(r[c])).join(",")),
  ].join("\n");
}

export function downloadCsv(filename, rows, columns) {
  const blob = new Blob([toCsv(rows, columns)], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const csvFilename = (section, days) => {
  const today = new Date().toISOString().slice(0, 10);
  return days
    ? `civichearth-${section}-${days}d-${today}.csv`
    : `civichearth-${section}-${today}.csv`;
};
